import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Slider from "react-slick";
import { BaseCarousel, CustomPagingStyled, IconButtonRight, IconButtonleft, SliderStyled, Wrap, WrapTitle, } from "./style";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
export default function Carousel({ children, slidesToShow = 4, autoplay = false, dots = true, speed = 500, slidesToScroll = 1, arrows = true, titleLabel, buttonLabel, buttonAction, }) {
    const [sliderRef, setSliderRef] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const settings = {
        dots,
        infinite: true,
        slidesToShow,
        slidesToScroll,
        arrows: false,
        autoplay,
        autoplaySpeed: speed,
        pauseOnHover: true,
        beforeChange: (_oldIndex, newIndex) => setCurrentSlide(newIndex),
        customPaging: (i) => (_jsx(CustomPagingStyled, { currentSlide: currentSlide === i })),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: Math.max(slidesToShow - 1, 1),
                },
            },
            {
                breakpoint: 990,
                settings: {
                    slidesToShow: Math.max(slidesToShow - 2, 1),
                },
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    return (_jsxs(Wrap, { children: [titleLabel && (_jsxs(WrapTitle, { children: [_jsx(Typography, Object.assign({ variant: "h4", component: "h4" }, { children: titleLabel })), _jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(ArrowForwardIcon, {}), onClick: buttonAction }, { children: buttonLabel }))] })), _jsxs(BaseCarousel, Object.assign({ hasArrows: arrows }, { children: [_jsx(SliderStyled, { children: _jsx(Slider, Object.assign({ ref: (slider) => setSliderRef(slider) }, settings, { children: children })) }), arrows && (_jsxs(_Fragment, { children: [_jsx(IconButtonleft, { children: _jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(ArrowBackIcon, {}), onClick: sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.slickPrev }, { children: buttonLabel })) }), _jsx(IconButtonRight, { children: _jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(ArrowForwardIcon, {}), onClick: sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.slickNext }, { children: buttonLabel })) })] }))] }))] }));
}
